import { render } from "./PatientsDatatableTDStart.vue?vue&type=template&id=1f7cc788"
import script from "./PatientsDatatableTDStart.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__